import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    padding: "1px 10px",
    position: "absolute",
    top: 2,
    left: "50%",
    transform: "translateX(-50%)",
    background: "white",
    borderRadius: 20,
  },
  startButton: {
    height: 18,
    width: 18,
    padding: 2,
    minHeight: "auto",
    position: "relative",
    top: -2,
    margin: "0 5px",
    boxShadow: "none",
  },
  editIcon: {
    background: theme.palette.events.bluePrimary,
    color: theme.palette.white,
    "&:hover": {
      background: theme.palette.events.blueAccent3,
      color: theme.palette.white,
    },
    "&:disabled": {
      background: theme.palette.events.grayPrimary,
      color: theme.palette.events.grayTertiary,
    },
  },
  stop: {
    backgroundColor: theme.palette.events.errorDark,
    color: theme.palette.white,
    "&:hover": {
      backgroundColor: "#FF555B",
    },
  },
  play: {
    backgroundColor: theme.palette.events.blueSecondary,
    color: theme.palette.white,
    "&:hover": {
      backgroundColor: theme.palette.events.blueAccent2,
    },
  },
  icon: {
    width: "100%",
    height: "100%",
  },
}));
